import React from "react";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { MailCheck, ArrowRight, Sparkles } from "lucide-react";

export function SummaryStage({ result }) {
  const summary = result?.summary || {};
  const email = result?.email;
  const sent = result?.welcome_email_sent;

  return (
    <div className="max-w-2xl" data-testid="summary-stage">
      <div className="h-14 w-14 rounded-full bg-accent/15 border border-accent/40 flex items-center justify-center mb-5">
        <MailCheck className="h-7 w-7 text-accent" />
      </div>
      <Badge variant="lime" className="mb-3">STEP 1 COMPLETE</Badge>
      <h2 className="font-display text-3xl font-bold tracking-tight">Here's what you told us</h2>
      <p className="text-muted-foreground text-sm mt-2 max-w-lg">
        {sent ? "A Welcome Email is on its way" : "Your details are saved"} to{" "}
        <span className="text-foreground font-semibold">{email}</span>. Open it and tap
        <span className="text-foreground font-medium"> "Start Self-Service Provisioning"</span> to create your login
        and set up your workspace. <span className="text-accent">Can't find it? Check your spam / junk folder.</span>
      </p>

      <div className="card-flat bg-surface p-5 mt-6" data-testid="summary-details">
        <dl className="divide-y divide-border/60">
          {Object.entries(summary).map(([label, value]) => {
            if (value == null || value === "" || (Array.isArray(value) && value.length === 0)) return null;
            return (
              <div key={label} className="flex justify-between gap-4 py-2 text-sm">
                <dt className="text-muted-foreground shrink-0">{label}</dt>
                <dd className="text-foreground text-right">{Array.isArray(value) ? value.join(", ") : String(value)}</dd>
              </div>
            );
          })}
        </dl>
      </div>

      <div className="card-flat bg-accent/10 border-accent/30 p-4 mt-5 flex gap-3" data-testid="summary-next">
        <Sparkles className="h-4 w-4 text-accent shrink-0 mt-0.5" />
        <div className="text-sm leading-relaxed">
          <span className="font-semibold">What happens next?</span> Your provisioning link is single-use and valid for
          7 days. When you open it, you'll create a username and password, then a short AI-guided wizard sets up your
          15-day Lestari Lite trial.
        </div>
      </div>

      <div className="mt-7">
        <a href="/login" data-testid="summary-signin-link">
          <Button variant="outline" className="gap-2">Already provisioned? Sign in <ArrowRight className="h-4 w-4" /></Button>
        </a>
      </div>
    </div>
  );
}
